<template>
<div class="k-page-content">
        <el-tabs v-model="activeName" class="box-eltab">
            <el-tab-pane label="菜单管理" name="first">
                <div class="k-page-common">
                    <div class="k-common-header">
                        <div class="k-filter-option k-filter-input" style="margin-bottom:0;">
                            <el-form :inline="true" :model="searchForm" size="mini" ref="searchForm" :rules="rules.searchForm">
                                <el-form-item label="菜单名称" prop="name">
                                    <el-input v-model="searchForm.name" placeholder="请填写菜单名称"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="doSearch">查询</el-button>
                                    <el-button type="primary" @click="reset">重置</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="k-common-con">
                        <div class="k-table-wrapper">
                            <div class="k-table-toolbar" style="margin-top:0;">
                                <div>
                                    <el-button type="primary" size="mini" @click="handelAddOpen">添加菜单</el-button>
                                </div>
                            </div>
                            <div class="k-table-con">
                                <el-table
                                    :data="tableData.data"
                                    style="width: 100%"
                                    row-key="id"
                                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                                    border
                                    stripe
                                    ref = "table"
                                    highlight-current-row
                                    @sort-change="sortChange"
                                    :height="tableHeight">

                                <el-table-column
                                        fixed
                                        prop="name"
                                        label="菜单名称"
                                        width="200">
                                </el-table-column>
                                <el-table-column
                                        prop="pid_text"
                                        label="所属父级"
                                        width="200">
                                </el-table-column>
                                <el-table-column
                                        prop="level"
                                        label="所属层级"
                                        width="100">
                                </el-table-column>
                                <el-table-column
                                        prop="menu_sort"
                                        label="排序"
                                        width="100">
                                </el-table-column>
                                <el-table-column
                                        prop="perm"
                                        label="权限键"
                                        width="150">
                                </el-table-column>
                                <el-table-column
                                        prop="url"
                                        label="请求地址"
                                        width="150">
                                </el-table-column>
                                <el-table-column
                                        prop="icon"
                                        label="图标"
                                        width="150">
                                </el-table-column>
                                <el-table-column
                                        prop="create_time"
                                        label="创建时间"
                                        width="200"
                                        sortable="custom">
                                </el-table-column>
                                <el-table-column
                                        prop="update_time"
                                        label="修改时间"
                                        width="200"
                                        sortable="custom">
                                </el-table-column>
                                <el-table-column
                                        prop="is_show_text"
                                        label="显示"
                                        fixed="right"
                                        width="60">
                                </el-table-column>
                                <el-table-column
                                        fixed="right"
                                        label="操作"
                                        min-width="150">
                                    <template slot-scope="scope">
                                        <el-button @click="handleTableEditOpen(scope.row)" type="text" :size="size">编辑</el-button>
                                        <el-button v-if="scope.row.is_show == 'HIDE'" @click="handleTableChangeShow(scope.row)" type="text" :size="size">显示</el-button>
                                        <el-button v-else @click="handleTableChangeShow(scope.row)" type="text" :size="size">隐藏</el-button>
                                        <el-button @click="handleTableDelete(scope.row)" type="text" :size="size" class="c-danger">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>

                            </el-table>
                            <el-pagination
                                background
                                ref="pagination"
                                @current-change="handleCurrentChange"
                                :current-page="tableData.current_page | number"
                                :page-size="tableData.per_page | number"
                                layout="total, prev, pager, next, jumper"
                                :total="tableData.total | number">
                            </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    
    <el-drawer
        custom-class="k-drawer"
        :visible.sync="addFormVisiable"
        direction="rtl"
        size="40%">
        <el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px">
            <div class="drawer-header">
                <div class="header-title">
                    <span>添加菜单</span>
                    <i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
                </div>
            </div>
            <div class="drawer-content">
                    <el-form-item label="菜单名称" prop="name">
                        <el-input v-model="addForm.name" placeholder="请填写菜单名称"></el-input>
                    </el-form-item>

                    <el-form-item label="权限键" prop="perm">
                        <el-input v-model="addForm.perm" placeholder="请填写菜单动作"></el-input>
                    </el-form-item>

                    <el-form-item label="菜单地址" prop="url">
                        <el-input v-model="addForm.url" placeholder="请填写菜单地址"></el-input>
                    </el-form-item>

                    <el-form-item label="菜单图标" prop="icon">
                        <el-input v-model="addForm.icon" placeholder="请填写菜单图标"></el-input>
                    </el-form-item>

                    <el-form-item label="排序" prop="menu_sort">
                        <el-input v-model.number="addForm.menu_sort" placeholder="请填写菜单排序"></el-input>
                    </el-form-item>

                    <el-form-item label="所属父级" prop="pid">
                        <el-select v-model="addForm.pid" clearable placeholder="请选择所属父级">
                            <el-option v-for="item in options.topMenus" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="是否显示" prop="is_show">
                        <el-radio v-model="addForm.is_show" label="SHOW">显示</el-radio>
                        <el-radio v-model="addForm.is_show" label="HIDE">隐藏</el-radio>
                    </el-form-item>
            </div>
            <div class="drawer-footer">
                <el-button type="primary" @click="handelAdd" :size='size'>提交</el-button>
                <el-button :size='size' @click="addFormVisiable = false">取消</el-button>
            </div>
        </el-form>
    </el-drawer>
    
    <el-drawer
        custom-class="k-drawer"
        :visible.sync="editFormVisiable"
        direction="rtl"
        size="40%">
        <el-form :model="editForm" ref="editForm" :size="size" :rules="rules.editForm" label-width="110px">
            <div class="drawer-header">
                <div class="header-title">
                    <span>编辑菜单</span>
                    <i class="el-icon-close k-drawer-close" @click="editFormVisiable = false"></i>
                </div>
            </div>
            <div class="drawer-content">
                <el-form-item label="菜单名称" prop="name">
                    <el-input v-model="editForm.name" placeholder="请填写菜单名称"></el-input>
                </el-form-item>

                <el-form-item label="权限键" prop="perm">
                    <el-input v-model="editForm.perm" placeholder="请填写菜单动作"></el-input>
                </el-form-item>

                <el-form-item label="菜单地址" prop="url">
                    <el-input v-model="editForm.url" placeholder="请填写菜单地址"></el-input>
                </el-form-item>

                <el-form-item label="菜单图标" prop="icon">
                    <el-input v-model="editForm.icon" placeholder="请填写菜单图标"></el-input>
                </el-form-item>

                <el-form-item label="排序" prop="menu_sort">
                    <el-input v-model.number="editForm.menu_sort" placeholder="请填写菜单排序"></el-input>
                </el-form-item>

                <el-form-item label="所属父级" prop="pid">
                    <el-select v-model="editForm.pid" clearable placeholder="请选择所属父级">
                        <el-option v-for="item in options.topMenus" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="是否显示" prop="is_show">
                    <el-radio v-model="editForm.is_show" label="SHOW">显示</el-radio>
                    <el-radio v-model="editForm.is_show" label="HIDE">隐藏</el-radio>
                </el-form-item>
            </div>
            <div class="drawer-footer">
                <el-button type="primary" @click="handleTableEdit" :size='size'>提交</el-button>
                <el-button :size='size' @click="editFormVisiable = false">取消</el-button>
            </div>
        </el-form>
    </el-drawer>
</div>
</template>
<script>
export default {
  props: ['info'],
  data() {
      return {
          addFormVisiable: false,
          editFormVisiable: false,
          checkSkVisiable: false,
          activeName: 'first',
          size:'mini',
          options: {
              topMenus: [],
              expands: {},
              apiVersions: {
                  'API_V1': 'V1',
              }
          },
          searchForm: {
              name: '',
          },
          resetSearch: {
              name: '',
          },
          addForm: {
              name: '',
              perm: '',
              menu_sort:0,
              pid:'',
              url:'',
              icon:'',
              is_show:'HIDE'
          },
          editForm: {
              name: '',
              perm: '',
              menu_sort:0,
              pid:'',
              url:'',
              icon:'',
              is_show:'HIDE'
          },
          checkSkForm: {
              id: '',
              secret_key: ''
          },
          checkSk: {
              show: false,
              text: '显示',
          },
          rules: {
              searchForm: {
                  'name': [
                      {max: 50, message: '请填写正确的菜单名称', trigger: ['change', 'blur']}
                  ],
              },
              addForm: {
                  'name': [
                      {required: true, message: '请填写菜单名称', trigger: ['change', 'blur']},
                      {max: 50, message: '请填写正确的菜单名称，长度不超过 50', trigger: ['change', 'blur']}
                  ],
                  'perm': [
                      {max: 50, message: '请填写正确的权限键，长度不超过 50', trigger: ['change', 'blur']}
                  ],
                  'url': [
                      {max: 50, message: '请填写正确的菜单地址，长度不超过 50', trigger: ['change', 'blur']}
                  ],
                  'icon': [
                      {max: 50, message: '请填写正确的菜单图标，长度不超过 50', trigger: ['change', 'blur']}
                  ],
                  'menu_sort': [
                      {type: 'number', min: 0, message: '请填写正确的排序', trigger: ['change', 'blur']}
                  ],
                  'is_show': [
                      {required: true, min: 0, message: '请选择菜单显示状态', trigger: ['change', 'blur']}
                  ]
              },
              editForm: {
                  'name': [
                      {required: true, message: '请填写菜单名称', trigger: ['change', 'blur']},
                      {max: 50, message: '请填写正确的菜单名称，长度不超过 50', trigger: ['change', 'blur']}
                  ],
                  'perm': [
                      {max: 50, message: '请填写正确的权限键，长度不超过 50', trigger: ['change', 'blur']}
                  ],
                  'url': [
                      {max: 50, message: '请填写正确的菜单地址，长度不超过 50', trigger: ['change', 'blur']}
                  ],
                  'icon': [
                      {max: 50, message: '请填写正确的菜单图标，长度不超过 50', trigger: ['change', 'blur']}
                  ],
                  'menu_sort': [
                      {type: 'number', min: 0, message: '请填写正确的排序', trigger: ['change', 'blur']}
                  ],
                  'is_show': [
                      {required: true, min: 0, message: '请选择菜单显示状态', trigger: ['change', 'blur']}
                  ]
              }
          },
          tableData: {
              total: 0,
              per_page: 15,
              current_page: 1,
              last_page: 0,
              data: []
          }
      }
  },
  computed: {
      tableHeight: function () {
          return window.innerHeight - 320;
      }
  },
  methods: {
      reset: function () {
          this.searchForm = this.resetSearch;
          this.doSearch();
      },
      handleSearch: function (params, page, prop, order) {
  
          this.$refs['searchForm'].validate(function (valid) {
  
              if (valid) {
                  this.loading = true;
  
                  var param = Object.assign({}, params);
  
                  param['page'] = page ? page : 1;
                  param['prop'] = prop ? prop : 'id';
                  param['order'] = order ? order : 'desc';
				  this.$api.management.menuList(param).then(res=>{
					  if (res.code === 0) {
					      this.tableData = res.data;
					    
					      this.$message({
					          showClose: true,
					          message: '查询应用列表信息成功！',
					          type: 'success'
					      });
					  } else {
					      var message = '查询应用列表信息失败！';
					      if (res.message) {
					          message = res.message;
					      }
					      this.$message({
					          showClose: true,
					          message: message,
					          type: 'error'
					      });
					  }
					  this.loading = false
				  })
  
              } else {
                  this.$message({
                      showClose: true,
                      message: '请填写正确的信息！',
                      type: 'warning'
                  });
              }
          }.bind(this));
      },
  
      // 执行查询
      doSearch: function (event) {
          var query = this.searchForm;
          query['_t'] = Date.parse(new Date());
          this.$router.push({ path: this.$route.path, query: query});
      },
  
      // 排序
      sortChange: function (e) {
          var order;
          var prop = e.prop;
          if (e.order == 'ascending') {
              order = 'asc';
          } else if (e.order == 'descending') {
              order = 'desc';
          } else {
              prop = this.resetSearch.prop;
              order = this.resetSearch.order;
          }
          this.handleSearch(this.searchForm, 1, prop, order);
      },
  
      // 改变当前页 page
      handleCurrentChange: function (val) {
          this.handleSearch(this.searchForm, val);
      },
  
      // 添加菜单
      handelAddOpen: function () {
          this.addFormVisiable = true;
      },
  
      // 添加菜单
      handelAdd: function () {
  
          this.$refs['addForm'].validate(function (valid) {
              if (valid) {
                  this.loading = true;
				  this.$api.http.post('management/menuAdd',this.addForm).then(res => {
					  if (res.code === 0) {
					    
					      // 重新获取所有的父级
					      this.getTopMenus();
					      // 重新加载表格
					      this.handleSearch({});
					    
					      this.$message({
					          showClose: true,
					          message: '添加菜单成功！',
					          type: 'success'
					      });
						  this.addFormVisiable = false;
					  } else {
					      var message = '添加菜单失败！';
					    
					      if (res.message) {
					          message = res.message;
					      }
					    
					      this.$notify({
					          showClose: true,
					          message: message,
					          type: 'warning'
					      });
					  }
					  this.loading = false
				  })
  
              } else {
                  this.$message({
                      showClose: true,
                      message: '请填写正确的信息！',
                      type: 'warning'
                  });
              }
          }.bind(this));
      },
  
      // 打开编辑菜单弹窗
      handleTableEditOpen: function (row) {
          this.loading = true;
		  this.$api.http.get('management/menuGet',{id:row.id}).then(res => {
			  if (res.code === 0) {
			      this.editForm = res.data;
			      if (this.editForm.pid == 0) {
			          this.editForm.pid = '';
			      }
			    
			      this.$message({
			          showClose: true,
			          message: '查询菜单信息成功！',
			          type: 'success'
			      });
			      this.editFormVisiable = true;
			  } else {
			      var message = '查询菜单信息失败！';
			    
			      if (res.message) {
			          message = res.message;
			      }
			    
			      this.$notify({
			          showClose: true,
			          message: message,
			          type: 'warning'
			      });
			  }
			  this.loading = false
		  })
      },
  
      // 编辑菜单
      handleTableEdit: function () {
  
          this.$refs['editForm'].validate(function (valid) {
              if (valid) {
                  this.loading = true;
				  this.$api.http.post('management/menuEdit',this.editForm).then(res => {
					  if (res.code === 0) {
					      var data = this.tableData.data;
					      data.forEach(function (item, index) {
					          if (item.id == res.data.id) {
					              this.$set(data, index, res.data);
					          } else if (item.children) {
					              item.children.forEach(function (value, key) {
					                  if (value.id == res.data.id) {
					                      this.$set(item.children, key, res.data);
					                  }
					              }.bind(this));
					          }
					      }.bind(this));
					    
					      this.$message({
					          showClose: true,
					          message: '修改菜单信息成功！',
					          type: 'success'
					      });
						  this.editFormVisiable = false;
					  } else {
					      var message = '修改菜单信息失败！';
					    
					      if (res.message) {
					          message = res.message;
					      }
					    
					      this.$notify({
					          showClose: true,
					          message: message,
					          type: 'warning'
					      });
					  }
					  this.loading = false
				  })
  
              } else {
                  this.$message({
                      showClose: true,
                      message: '请填写正确的信息！',
                      type: 'warning'
                  });
              }
          }.bind(this));
      },
  
      // 删除菜单
      handleTableDelete: function (row) {
  
          this.$confirm('此操作将永久删除该菜单, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(function() {
              this.loading = true;
			  this.$api.http.get('management/menuDelete', {id:row.id}).then(res => {
				  if (res.code === 0) {
				      var data = this.tableData.data;
				    
				      data.forEach(function (item, index) {
				          if (item.id == res.data.id) {
				              this.$delete(data, index);
				          } else if (item.children) {
				              item.children.forEach(function (value, key) {
				                  if (value.id == res.data.id) {
				                      this.$delete(item.children, key);
				                  }
				              }.bind(this));
				          }
				      }.bind(this));
				    
				      this.$message({
				          showClose: true,
				          message: '删除菜单信息成功！',
				          type: 'success'
				      });
				    
				  } else {
				      var message = '删除菜单信息失败！';
				    
				      if (res.message) {
				          message = res.message;
				      }
				    
				      this.$notify({
				          showClose: true,
				          message: message,
				          type: 'warning'
				      });
				  }
				  this.loading = false
			  })
          }.bind(this))
      },
  
      // 修改菜单显示状态
      handleTableChangeShow: function (row) {
  
          this.$confirm('此操作将修改该菜单的显示状态, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(function() {
              this.loading = true;
			  this.$api.http.get('management/changeShow',{id:row.id}).then(res => {
				  if (res.code === 0) {
				      var data = this.tableData.data;
				    
				      data.forEach(function (item, index) {
				          if (item.id == res.data.id) {
				              this.$set(data, index, res.data);
				          } else if (item.children) {
				              item.children.forEach(function (value, key) {
				                  if (value.id == res.data.id) {
				                      this.$set(item.children, key, res.data);
				                  }
				              }.bind(this));
				          }
				      }.bind(this));
				    
				      this.$message({
				          showClose: true,
				          message: '菜单信息修改成功！',
				          type: 'success'
				      });
				    
				  } else {
				      var message = '菜单信息修改失败！';
				    
				      if (res.message) {
				          message = res.message;
				      }
				    
				      this.$notify({
				          showClose: true,
				          message: message,
				          type: 'warning'
				      });
				  }
				  this.loading = false
			  })
          }.bind(this))
      },
  
      // 查询所有的父级菜单
      getTopMenus: function () {
  
          // 查询父级菜单
		  this.$api.http.get('management/topMenus',{}).then(res => {
			  if (res.code === 0) {
			      this.options.topMenus = res.data;
			  } else {
			      var message = '加载表单选项失败！';
			    
			      if (res.message) {
			          message = res.message;
			      }
			    
			      this.$notify({
			          showClose: true,
			          message: message,
			          type: 'warning'
			      });
			  }
			  this.loading = false
		  })
      },
  
      // 生成查询参数
      makeParams: function (query) {
          var params = {};
          params['name'] = query.name ? query.name : this.resetSearch.name;
  
          this.searchForm = params;
          return params;
      }
  },
  mounted: function () {
      var params = this.makeParams(this.$route.query);
      this.handleSearch(params);
      this.getTopMenus();
  },
  beforeRouteUpdate: function (to, from, next) {
      var params = this.makeParams(to.query);
      this.handleSearch(params);
      next();
  }
}
</script>